import { apiService } from "../../services/apiService";
import { utilService } from "../../services/utilService";
import { apiServiceConstants } from "../../constants";

import {
  ForgotParams,
  ForgotPasswordUserResult,
  RespForgotPasswordUser,
} from "./ForgotPassword.model";


const forgot = async (params: ForgotParams): Promise<ForgotPasswordUserResult> => {
  const respApiResult = await apiService
    .apiCall(
      "auth/reset-password/?reg_code=" + params.reg_code,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as RespForgotPasswordUser;
      const result: ForgotPasswordUserResult = {
        isSuccess     : response.isSuccess,
        status        : response.status,
        message       : response.message,
        username      : response.result?.[0]?.username
      };
      return result;
    })
    .catch((err) => {
      const result: ForgotPasswordUserResult = {
        isSuccess  : false,
        message    : err.message,
        status     : err.status,
      };
      return result;
    });

  return respApiResult;
};

const forgotUsername = async (params: ForgotParams): Promise<ForgotPasswordUserResult> => {
  const respApiResult = await apiService
    .apiCall(
      "auth/forgot-username/?reg_code=" + params.reg_code,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as any;
      const result: any = {
        isSuccess     : response.isSuccess,
        status        : response.status,
        message       : response.message,
        username      : response.result?.[0]?.username
      };
      return result;
    })
    .catch((err) => {
      const result: ForgotPasswordUserResult = {
        isSuccess  : false,
        message    : err.message,
        status     : err.status,
      };
      return result;
    });

  return respApiResult;
};


export const forgotService = {
  forgot,
  forgotUsername
}
